import styled from 'styled-components';

import { Text, TextProps } from '../../cdl/Text/Text';
import { theme } from '../ui/theme';

interface LabelTextProps extends TextProps {
    disabled?: boolean;
}

export const LabelText = styled(Text).attrs({ variant: 'fieldLabel' })<LabelTextProps>`
    color: ${(props) => (props.disabled ? theme.colors.foreground.disabled : theme.colors.foreground.default)};
`;
